import {
  reactSelectInlineError,
  SrcInfoContainer
} from '@nile/banyan/src/Utils/style';
import {
  getTranslatedText,
  AppContext,
  Icon,
  SelectionSheet,
  FieldTitle,
  FieldValue,
  BackgroundIcon,
  useProduct,
  COMMON_CONSTANTS
} from '@nile/components';
import { HeaderTag } from '@nile/components/src';
import {
  Popover,
  Sheet,
  Heading,
  Button,
  Checkbox,
  ChoiceList,
  Avatar
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { useQuery, useLazyQuery } from '@apollo/client';
import { UserPlus } from '@styled-icons/fa-solid/UserPlus';
import { cloneDeep } from 'lodash';
import React, {
  createRef,
  useCallback,
  useContext,
  useEffect,
  useState
} from 'react';
import styled from 'styled-components';
import {
  GET_CLIENTS,
  GET_REQUESTERS_BY_CRITERIA,
  GET_REQUESTERS_BY_CRITERIA_ASSOCIATIONS,
  AccountClient
} from '@nile/graphql';
import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator
} from '@nile/components/src/Pebbles/select';
import Select from 'react-select';
import { Tooltip } from 'react-clone-tippy';
import { FormattedMessage, injectIntl } from 'react-intl';
import envConfig from '@nile/home/src/Config/env';
import MultipleNamesHandler from '@nile/components/src/Pebbles/multipleNamesHandler';
import { GET_COMPANY_USERS } from '@nile/graphql/src/Query/automationrules';
import { GET_COMPANY_SITE_LIST } from '@nile/itsm/src/graphql';
import * as _ from 'lodash';

function generate() {
  const hexValues = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'a',
    'b',
    'c',
    'd',
    'e'
  ];

  function populate(a) {
    for (let i = 0; i < 6; i++) {
      const x = Math.round(Math.random() * 14);
      const y = hexValues[x];
      a += y;
    }
    return a;
  }
  const newColor1 = populate('#');
  const newColor2 = populate('#');
  const angle = Math.round(Math.random() * 360);

  const gradient = `linear-gradient(180deg, ${newColor1}, ${newColor2})`;
  return gradient;
}

function getDimensions(ele) {
  const { height } = ele.getBoundingClientRect();
  const offsetTop = ele.offsetTop;
  const offsetBottom = offsetTop + height;

  return {
    height,
    offsetTop,
    offsetBottom
  };
}

function RenderPermissions(props) {
  const { module, feature, availableRoleFeatureList, intl } = props;
  const [popoverActive, setPopoverActive] = useState(false);
  let featureToCompare = availableRoleFeatureList[module].find(
    (el) => el.feature.featureId === feature.feature.featureId
  );
  if (!featureToCompare) return '';
  const togglePopoverActive = () => {
    setPopoverActive(!popoverActive);
  };
  const activator = (
    <div className="full-height ptr fx actr" onClick={togglePopoverActive}>
      {featureToCompare.operationList.map((op, idx) => {
        return (
          <div className="flex center">
            <div
              id={`${feature.feature.key}-${op?.name}`}
              className={`ml8 ${
                feature.operationList.find(
                  (el) => el.operationId === op.operationId
                )
                  ? ''
                  : 'disabled'
              }`}
            >
              <FormattedMessage id={op?.labelKey} />
            </div>
            {idx !== featureToCompare.operationList.length - 1 ? (
              <div className="dot-separator" />
            ) : (
              <div className="triangle-down disabled ml8" />
            )}
          </div>
        );
      })}
    </div>
  );

  const options = featureToCompare.operationList.map((el) => {
    return {
      name: el.operationId,
      label: el?.labelKey ? getTranslatedText(intl, el?.labelKey) : el?.name,
      value: el.operationId,
      title: el.name
    };
  });

  const selected = feature.operationList.map((el) => el.operationId);

  const handleChange = (changes) => {
    let selectedFeatures = featureToCompare.operationList.filter((el) => {
      return changes.indexOf(el.operationId) > -1;
    });
    props.updateSelectedFeatures(selectedFeatures, module, feature);
  };

  return (
    <Popover
      active={popoverActive}
      activator={activator}
      onClose={togglePopoverActive}
    >
      <div id={`${feature.feature.key}`} className="w100px fx actr jctr p8">
        <ChoiceList
          allowMultiple
          choices={options}
          selected={selected}
          onChange={handleChange}
        />
      </div>
    </Popover>
  );
}

function RolePermissionCascade(props) {
  const {
    intl,
    availableGroupings,
    availableRoleFeatureList,
    selectedRoleFeatureList,
    allUsers,
    errors,
    page,
    dependancyErrors
  } = props;
  const [selectedRoleList, setSelectedRoleList] = useState(
    selectedRoleFeatureList
  );
  useEffect(() => {
    let initSelection = {};
    for (var prop in availableRoleFeatureList) {
      initSelection[prop] = availableRoleFeatureList[prop].map((ft) => {
        let opList = selectedRoleFeatureList[prop]?.find(
          (r) => r.feature.featureId === ft.feature.featureId
        )?.operationList;
        return {
          ...ft,
          operationList: opList || []
        };
      });
    }
    setSelectedRoleList(initSelection);
  }, [JSON.stringify(availableRoleFeatureList)]);
  const [focusedSection, setFocusedSection] = useState('Associate employees');
  const [refMap] = useState(
    (function() {
      let _refMap = {};
      _refMap['Associate employees'] = createRef();
      for (let i = 0; i < availableGroupings.length; i++) {
        _refMap[availableGroupings[i]] = createRef();
      }
      return _refMap;
    })()
  );

  const wrapperRef = createRef();
  const handleFeaturePermission = (feature, module, isChecked) => {
    const updatedModule = cloneDeep(selectedRoleList[module]);
    const updateIndex = updatedModule.findIndex(
      (el) => el.feature.featureId === feature.feature.featureId
    );
    updatedModule[updateIndex] = {
      ...updatedModule[updateIndex],
      operationList: !isChecked
        ? []
        : availableRoleFeatureList[module].find(
            (el) => el.feature.featureId === feature.feature.featureId
          ).operationList
    };
    setSelectedRoleList({
      ...selectedRoleList,
      [module]: updatedModule
    });
    props.updateSelectedRoleList({
      ...selectedRoleList,
      [module]: updatedModule
    });
  };
  const scrollIntoView = (section) => {
    refMap[section].current.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    // setFocusedSection(section);
  };

  useEffect(() => {
    const handleScroll = () => {
      let selected = null;
      for (let prop in refMap) {
        const ele = refMap[prop].current;
        const { height: wrapperHeight } = getDimensions(ele.parentNode);
        const scrollPosition = ele.parentNode.scrollTop + wrapperHeight;
        if (ele) {
          const { offsetBottom, offsetTop } = getDimensions(ele);
          if (ele.parentNode.scrollTop === 0) {
            selected = Object.keys(refMap)[0];
          } else if (ele.parentNode.scrollHeight === scrollPosition) {
            selected = Object.keys(refMap)[Object.keys(refMap).length - 1];
          } else if (
            scrollPosition > offsetTop &&
            scrollPosition < offsetBottom
          ) {
            selected = prop;
            break;
          }
        }
      }
      if (selected && selected !== focusedSection) {
        setFocusedSection(selected);
      }
    };
    window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, [focusedSection]);

  const updateSelectedFeatures = (featureList, module, feature) => {
    const updatedModule = cloneDeep(selectedRoleList[module]);
    const updateIndex = updatedModule.findIndex(
      (el) => el.feature.featureId === feature.feature.featureId
    );
    updatedModule[updateIndex] = {
      ...updatedModule[updateIndex],
      operationList: featureList
    };
    setSelectedRoleList({
      ...selectedRoleList,
      [module]: updatedModule
    });
    props.updateSelectedRoleList({
      ...selectedRoleList,
      [module]: updatedModule
    });
  };

  const [selectedItems, setSelectedItems] = useState(props.selectedUsers || []);
  const updateUserList = (selectedItems) => {
    setSelectedItems(selectedItems);
    props.updateSelectedEmployees(selectedItems);
  };

  return (
    <div className="fx full-height mt-20 white-transparent-bg h-auto">
      <div className="fw h-auto" ref={wrapperRef}>
        <div className="fhp full-width scroll pr40">
          <>
            <div className="mb40" ref={refMap['Associate employees']}>
              {page === 'technicianrole' ? (
                <AssociateEmployees
                  intl={intl}
                  updateUserList={updateUserList}
                  selectedItems={selectedItems}
                  allUsers={allUsers}
                  errors={errors}
                />
              ) : (
                <AssociateRequesters
                  intl={intl}
                  updateUserList={updateUserList}
                  selectedItems={selectedItems}
                  errors={errors}
                />
              )}
            </div>
            {Object.keys(selectedRoleList).map((module) => {
              const moduleErrors =
                dependancyErrors.find(
                  (el) =>
                    el.name ===
                    selectedRoleList[module][0].feature.permissionCategory.name
                )?.errors || [];
              return (
                <div
                  className="mb40"
                  ref={
                    refMap[
                      getTranslatedText(
                        intl,
                        selectedRoleList[module][0].feature.permissionCategory
                          .labelKey
                      )
                    ]
                  }
                >
                  <div className="flex mb10 pr-5">
                    <Heading element="h4" weight="Bold">
                      <FormattedMessage
                        id={
                          selectedRoleList[module][0].feature.permissionCategory
                            ?.labelKey
                        }
                      />
                    </Heading>
                  </div>

                  {selectedRoleList[module].map((feature) => {
                    const errorSection = moduleErrors.find(
                      (el) => el.name === feature.feature.key
                    );
                    const invalidPermissionModules = errorSection
                      ? errorSection.errors
                      : null;
                    const invalidPermissionErrorMessage = invalidPermissionModules
                      ? `${getTranslatedText(
                          intl,
                          'admin.roles.errorDependencies.tooltip'
                        )}${invalidPermissionModules.join(', ')}`
                      : '';
                    return (
                      <div
                        className="flex mr8 Role-Permission"
                        id={`${feature.feature.name?.split(' ')?.join('')}-${
                          feature.feature.featureId
                        }`}
                        name={`${feature.feature.name}-${feature.feature.featureId}`}
                      >
                        <div className="w50 flex center">
                          <div
                            id={`${feature.feature.name?.split(' ')?.join('')}`}
                            className={
                              feature.operationList.length ? '' : 'disabled'
                            }
                          >
                            <Checkbox
                              checked={feature.operationList.length}
                              label={getTranslatedText(
                                intl,
                                feature.feature.labelKey || feature.feature.name
                              )}
                              id={`${feature.feature.name}_${feature.feature.featureId}`}
                              name={`${feature.feature.name}-${feature.feature.featureId}`}
                              onChange={handleFeaturePermission.bind(
                                this,
                                feature,
                                module
                              )}
                            />
                          </div>
                          {invalidPermissionModules && (
                            <div className="mlauto mr-10">
                              <Tooltip
                                distance={35}
                                title={invalidPermissionErrorMessage}
                                position="top-start"
                                inertia
                                trigger="mouseenter"
                                animation="shift"
                                animateFill={false}
                              >
                                <SVGIcon name="InlineError" />
                              </Tooltip>
                            </div>
                          )}
                        </div>

                        <RenderPermissions
                          updateSelectedFeatures={updateSelectedFeatures}
                          availableRoleFeatureList={availableRoleFeatureList}
                          module={module}
                          feature={feature}
                          intl={intl}
                        />
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </>
        </div>
      </div>
      <div className="fx fcol min-width-255 ptb-30 right-nav h-auto pl20">
        <Grouping
          selected={focusedSection === 'Associate employees'}
          onClick={scrollIntoView.bind(this, 'Associate employees')}
        >
          <FormattedMessage id="admin.roles.associateEmployees" />
        </Grouping>
        {availableGroupings.map((item) => {
          const isInvalidPermissionPresent = dependancyErrors.find(
            (el) => el.name === item
          );
          return (
            <Grouping
              className="flex center"
              selected={focusedSection === item}
              onClick={scrollIntoView.bind(this, item)}
            >
              {item}
              {isInvalidPermissionPresent && <SVGIcon name="InlineError" />}
            </Grouping>
          );
        })}
      </div>
    </div>
  );
}

function AssociateEmployees(props) {
  const { intl } = props;
  const [sheetActive, setSheetActive] = useState(false);
  const toggleSheetActive = useCallback(
    () => setSheetActive((sheetActive) => !sheetActive),
    []
  );
  const { allUsers, selectedItems, errors } = props;
  const appContext = useContext(AppContext);
  const { user } = appContext;
  let sections = [];
  const userSection = {
    name: 'user',
    header: getTranslatedText(intl, 'admin.Technicianrole.associate.header'),
    items: allUsers
      .filter((el) => user.userId !== el.userId)
      .map((el) => {
        return {
          ...el,
          id: el.userId,
          name: el.name,
          label: `${el.firstName} ${el.lastName}`
        };
      })
  };
  sections.push(userSection);
  const updateParent = (selectedItem) => {
    props.updateUserList(selectedItem);
  };

  return (
    <div>
      <div className="flex mb10 pr-5">
        <div style={{ flex: '1 1' }}>
          <Heading element="h4" weight="Bold">
            <FormattedMessage id="admin.Technicianrole.h2.allTechnicians" />
          </Heading>
        </div>
        <div>
          <Button
            onClick={toggleSheetActive}
            id="associateBtn"
            icon={<SVGIcon name="AssignToMeIcon" />}
          >
            <FormattedMessage id="admin.Technicianrole.associateIcon" />
          </Button>
        </div>
      </div>
      {errors?.users && reactSelectInlineError(errors.users[0])}
      <div className="flex wrap">
        {selectedItems?.length ? (
          selectedItems.map((emp) => {
            return (
              <div className="flex center mb-8 fb-33">
                <div className="mr16">
                  <Avatar
                    initials={`${emp.firstName?.[0]}${emp.lastName?.[0] || ''}`}
                  />
                </div>
                <div>
                  <FieldTitle className="title">{`${emp.firstName ||
                    ''} ${emp.lastName || ''}`}</FieldTitle>
                </div>
              </div>
            );
          })
        ) : (
          <div> {getTranslatedText(intl, 'admin.Technicianrole.noUser')} </div>
        )}
      </div>
      <Sheet open={sheetActive} onClose={toggleSheetActive}>
        <SelectionSheet
          sections={sections}
          actions={props.actions}
          meta={{
            heading: getTranslatedText(
              intl,
              'admin.Technicianrole.associate.header'
            ),
            selectedTitle: getTranslatedText(
              intl,
              'admin.Technicianrole.associate.h2.select'
            )
          }}
          data={allUsers}
          selectedItems={selectedItems}
          toggleSheetActive={toggleSheetActive}
          updateParent={updateParent}
          isPromptConfirmation
          hideSelectedItems
        />
      </Sheet>
    </div>
  );
}

function AssociateRequesters(props) {
  const [sheetActive, setSheetActive] = useState(false);
  const toggleSheetActive = useCallback(
    () => setSheetActive((sheetActive) => !sheetActive),
    []
  );
  const [clientORSite, setClientORSite] = useState(null);
  const { intl, selectedItems, errors } = props;
  const [allUsers, setAllUsers] = useState([]);
  const appContext = useContext(AppContext);
  const { user } = appContext;
  const productType = useProduct();
  const [
    getClientORSiteUsers,
    { called, loading: userLoading, data }
  ] = useLazyQuery(
    productType === COMMON_CONSTANTS.MSP
      ? GET_REQUESTERS_BY_CRITERIA_ASSOCIATIONS
      : GET_COMPANY_USERS,
    {
      client: AccountClient,
      variables:
        productType === COMMON_CONSTANTS.MSP
          ? {
              input: {
                listInfo: {
                  condition: {
                    joinOperator: 'AND',
                    operands: [
                      {
                        attribute: 'client.accountId',
                        operator: 'is',
                        value: clientORSite?.accountId
                      }
                    ]
                  }
                }
              }
            }
          : {
              listInfo: {
                condition: {
                  joinOperator: 'AND',
                  operands: [
                    {
                      attribute: 'associations.site.id',
                      operator: 'is',
                      value: clientORSite?.id
                    }
                  ]
                },
                sort: [
                  {
                    attribute: 'name',
                    order: 'ASC'
                  }
                ]
              }
            },
      onCompleted(data) {
        const parsedUsers = _.get(
          data,
          productType === COMMON_CONSTANTS.MSP
            ? 'getClientUserAssociationsList.associations'
            : 'getCompanyUsersList.userList'
        ).map((el) => {
          el = productType === COMMON_CONSTANTS.MSP ? el.user : el;
          return {
            ...el,
            value: el.name,
            label: el.name,
            id: el.userId
          };
        });
        setAllUsers(parsedUsers);
      }
    }
  );

  const { loading, error, data: allClientORSiteData } = useQuery(
    productType === COMMON_CONSTANTS.MSP ? GET_CLIENTS : GET_COMPANY_SITE_LIST,
    {
      client: AccountClient,
      variables: {
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      }
    }
  );

  useEffect(() => {
    if (clientORSite) getClientORSiteUsers();
  }, [JSON.stringify(clientORSite)]);

  const onChangeField = (val) => {
    if (val) setClientORSite(val);
  };

  const getClientSelectionComponent = () => {
    return (
      <div className="container">
        <Select
          className={``}
          classNamePrefix="value_selector"
          formatGroupLabel={formatGroupLabel}
          components={{ IndicatorSeparator, DropdownIndicator }}
          title={getTranslatedText(
            intl,
            productType === COMMON_CONSTANTS.MSP
              ? 'admin.requesterrole.chooseclient'
              : 'admin.requesterrole.choosesite'
          )}
          onChange={onChangeField}
          options={
            allClientORSiteData
              ? _.get(
                  allClientORSiteData,
                  productType === COMMON_CONSTANTS.MSP
                    ? 'getClientList.clients'
                    : 'getCompanySiteList.sites'
                )?.map((el) => {
                  return {
                    ...el,
                    id: el.accountId || el.id,
                    name: el.name,
                    label: el.name,
                    value: el.name
                  };
                })
              : []
          }
          placeholder={getTranslatedText(
            intl,
            productType === COMMON_CONSTANTS.MSP
              ? 'admin.requesterrole.chooseclient'
              : 'admin.requesterrole.choosesite'
          )}
          menuPortalTarget={document.body}
          menuPlacement="auto"
          closeMenuOnScroll={(e) => {
            return (
              e.target &&
              e.target.classList &&
              !(e.target.classList.value.indexOf('menu-list') > -1)
            );
          }}
          name="valueselector"
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 })
          }}
          noOptionsMessage={() => {
            return loading ? 'Loading...' : 'No options';
          }}
        />
      </div>
    );
  };

  const sections = [];

  const userSection = {
    name: 'user',
    header: getTranslatedText(intl, 'admin.Technicianrole.associate.header'),
    items: allUsers,
    component: getClientSelectionComponent()
  };

  sections.push(userSection);
  const updateParent = (selectedItem) => {
    props.updateUserList(selectedItem);
  };

  return (
    <div>
      <div className="flex mb10 pr-5">
        <div style={{ flex: '1 1' }}>
          <Heading element="h4" weight="Bold">
            <FormattedMessage id="admin.Requesterrole.associate.header" />
          </Heading>
        </div>
        {loading ? (
          <div>loading...</div>
        ) : (
          <div>
            <Button
              onClick={toggleSheetActive}
              id="associateBtn"
              icon={<SVGIcon name="AssignToMeIcon" />}
            >
              <FormattedMessage id="admin.Technicianrole.associateIcon" />
            </Button>
          </div>
        )}
      </div>
      {errors?.users && reactSelectInlineError(errors.users[0])}
      <div className="flex wrap">
        {selectedItems?.length ? (
          selectedItems.map((emp) => {
            // const gradient = generate();

            const clientData = emp?.associations?.map((el) => {
              const clientList = {
                id: el.client.accountId,
                name: el.client.name
              };
              return clientList;
            });
            return (
              <div className="flex center mb-8 fb-33" key={emp.userId}>
                <div className="mr16">
                  <Avatar
                    initials={`${emp.firstName?.[0]}${emp.lastName?.[0] || ''}`}
                  />
                </div>
                <div>
                  <FieldTitle className="title">
                    {`${emp.firstName || ''} ${emp.lastName || ''}`}
                  </FieldTitle>
                  {productType === COMMON_CONSTANTS.MSP && (
                    <FieldValue className="value">
                      <MultipleNamesHandler
                        data={clientData}
                        fontSize="12px"
                        color="rgba(0,0,0,0.5)"
                      />
                    </FieldValue>
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <div>
            <FormattedMessage id="admin.Technicianrole.nouser" />
          </div>
        )}
      </div>
      <Sheet open={sheetActive} onClose={toggleSheetActive}>
        <SelectionSheet
          sections={sections}
          actions={props.actions}
          meta={{
            heading: getTranslatedText(
              intl,
              'admin.requesterrole.associate.header'
            ),
            selectedTitle: getTranslatedText(
              intl,
              'admin.Technicianrole.associate.h2.select'
            )
          }}
          data={allUsers}
          selectedItems={selectedItems}
          toggleSheetActive={toggleSheetActive}
          updateParent={updateParent}
          isPromptConfirmation
          hideSelectedItems
        />
      </Sheet>
    </div>
  );
}

const Grouping = styled.div`
  cursor: pointer;
  font-weight: 'bold';
  padding: 8px;
  padding-left: 20px;
  color: ${(props) => (props.selected ? '#000' : 'rgba(0, 0, 0, 0.3)')};
  // background-color: ${(props) => (props.selected ? '#39394E' : 'none')};
`;

export default injectIntl(RolePermissionCascade);
